import React from 'react';
import styled from 'styled-components';
import { remCalc } from '@lux/helpers';
import Anchor from '../Anchor';
import logo from '../../assets/images/logo.png';
var LogoAnchor = styled(Anchor).withConfig({
  displayName: "Logo__LogoAnchor",
  componentId: "sc-1ooewst-0"
})(["display:flex;justify-content:center;align-items:center;"]);
var LogoImg = styled.img.withConfig({
  displayName: "Logo__LogoImg",
  componentId: "sc-1ooewst-1"
})(["height:", ";"], remCalc(44));

var Logo = function Logo(_ref) {
  var baseUrl = _ref.baseUrl,
      link = _ref.link,
      alt = _ref.alt,
      padded = _ref.padded;
  return /*#__PURE__*/React.createElement(LogoAnchor, {
    href: "" + baseUrl + link,
    padded: padded
  }, /*#__PURE__*/React.createElement(LogoImg, {
    src: logo,
    alt: alt
  }));
};

export default Logo;